import React from 'react'
import { Div, ToolTip } from '@driftt/tide-core'

export const NO_USER_COPY = 'Not a Drift User.'

export const MANAGED_BY_SF_COPY = 'This account is managed by Salesforce.'

const name = () => (
  <ToolTip
    component={'Company Name'}
    flow='down'
  >
    Name
  </ToolTip>
)

const selectAll = (bulkSelect) => (
  <ToolTip
    component={'Select All'}
    flow='down'
    className='select-all-tooltip'
  >
    {bulkSelect()}
  </ToolTip>
)

const domain = () => (
  <ToolTip
    component={'Company Website'}
    flow='down'
  >
    Domain
  </ToolTip>
)

const owner = () => (
  <ToolTip
    component={<Div>The person in your company that <br/>owns this account</Div>}
    flow='down'
  >
    Owner
  </ToolTip>
)

const lastActive = () => (
  <ToolTip
    component={<Div>The last time this account was updated</Div>}
    flow='down'
  >
    Last updated
  </ToolTip>
)

const type = () => (
  <ToolTip
    component={<Div>See whether this account is part of <br/>your ABM efforts here</Div>}
    flow='down'
  >
    Type
  </ToolTip>
)

export const AccountsTableColumns = (onChange, bulkSelect) => ([
  {
    label: selectAll(bulkSelect),
    sortable: false,
    value: 'select',
    width: '50px'
  },
  {
    label: name(),
    sortable: true,
    value: 'name',
    onClick: onChange,
    width: '200px'
  },
  {
    label: domain(),
    sortable: true,
    value: 'domain',
    onClick: onChange,
    width: '200px'
  },
  {
    label: owner(),
    sortable: true,
    value: 'ownerId',
    onClick: onChange,
    width: '200px'
  },
  {
    label: lastActive(),
    sortable: true,
    value: 'updateDateTime',
    onClick: onChange,
    width: '100px'
  },
  {
    label: type(),
    sortable: true,
    value: 'targeted',
    onClick: onChange,
    width: '50px'
  },
  {
    label: '',
    width: '80px'
  },
])
